import { z } from 'zod';
/** NIST AI 200-1 activity categories. */
export const AI_ACTIVITIES = [
    'assess_classify', 'assist_advise', 'augment', 'automate',
    'detect', 'diagnose', 'generate', 'infer', 'interact',
    'monitor', 'optimize', 'plan_schedule', 'retrieve',
];
export const aiActivitySchema = z.array(z.enum(AI_ACTIVITIES)).default([]);
export const AI_ACTIVITY_LABELS = {
    assess_classify: 'Assess & Classify',
    assist_advise: 'Assist & Advise',
    augment: 'Augment',
    automate: 'Automate',
    detect: 'Detect',
    diagnose: 'Diagnose',
    generate: 'Generate',
    infer: 'Infer',
    interact: 'Interact',
    monitor: 'Monitor',
    optimize: 'Optimize',
    plan_schedule: 'Plan & Schedule',
    retrieve: 'Retrieve',
};
//# sourceMappingURL=ai-activities.js.map